<template>
  <b-alert
    :show="!!(successMsg || errorMsg)"
    class="position-fixed fixed-bottom m-0 rounded-0 service-lib-alert"
    :variant="!isError ? 'success' : 'danger'"
  >
    <div class="d-flex justify-content-between align-items-center">
      <div class="w-100 d-flex justify-content-center">
        <b-icon :icon="!isError ? 'check' : 'exclamation-triangle'" class="mr-2" />
        <strong class="font-weight-bold">{{ !isError ? successMsg : errorMsg }}</strong>
      </div>
      <button
        class="close-btn d-flex justify-content-center align-items-center bg-white border-0 p-0"
        @click.prevent="handleClose"
      >
        <b-icon icon="times" class="h3 mb-0" :class="!isError ? 'text-success' : 'text-danger'" />
      </button>
    </div>
  </b-alert>
</template>

<script>
export default {
  props: {
    errorMsg: {
      type: String,
      default: ''
    },
    successMsg: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!this.isError) {
      setTimeout(() => this.handleClose(), 5000)
    }
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/z-index';
@import '../../scss/colors';
.close-btn {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  background: white !important;
}

.service-lib-alert {
  z-index: $zindex-tooltip + 11 !important;
  border-color: transparent !important;
}

.alert-danger {
  background-color: $danger;
  color: white;
}

.alert-success {
  background-color: $success;
  color: white;
}
</style>
